import React, { Component } from 'react';
import { BiChevronLeftCircle, BiChevronRightCircle } from 'react-icons/bi';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import { Gallery, Item } from 'react-photoswipe-gallery';
import axios from 'axios';

export default class InfoAPIView extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            isHiddenInfoPanel: false,
        };
    }

    componentDidMount() {
        var path = `${window.config.toolbar?.info?.baseurl ?? ''}${
            this.props.api
        }`;
        axios
            .get(path)
            .then((res) => res.data)
            .then((res) => {
                console.log("request successful", res.data);
                this.setState({ data: res.data });
            })
            .catch((err) => {
                alert('Đường dẫn tài nguyên bị lỗi');
                window.closeInfo();
            });
    }

    getContentView(data) {
        if (data == null) return;
        // if (data.arModel != null && data.arModel.length > 0)
        //     window.showInfo('3d_web', data.arModel[0].path);
        return (
            <div className="content">
                <div className="meta-panel">
                    <h1 className="title" align="center">
                        <font color="#ffbc50">{data.name}</font>
                    </h1>
                    <table>
                        <tr>
                            <td>Mã hiện vật</td>
                            <td>{data?.code}</td>
                        </tr>
                        <tr>
                            <td>Danh mục</td>
                            <td>{data.category?.name}</td>
                        </tr>
                        <tr>
                            <td>Phòng trưng bày</td>
                            <td>{data.showroom?.name}</td>
                        </tr>
                    </table>
                    <p
                        className="description"
                        dangerouslySetInnerHTML={{ __html: data.content }}
                    ></p>
                    <div className="media">
                        <h3></h3>
                        <div className="item-value">
                            <Gallery>
                                {data.images.map((item) => (
                                    <Item
                                        key={'gallery' + item.id}
                                        original={item.path}
                                        thumbnail={item.path}
                                        width="1024"
                                        height="768"
                                    >
                                        {({ ref, open }) => (
                                            <img
                                                ref={ref}
                                                onClick={open}
                                                src={item.path}
                                            />
                                        )}
                                    </Item>
                                ))}
                            </Gallery>
                        </div>
                        <div className="item-value">
                            {data.videos?.map((item, i) => (
                                <video key={'video' + i} controls>
                                    <source
                                        src={item.path}
                                        type={item.mime ?? 'video/mp4'}
                                    />
                                </video>
                            ))}
                        </div>
                        <div className="item-value">
                            {data.audios?.map((item, i) => (
                                <audio key={'video' + i} controls>
                                    <source
                                        src={item.path}
                                        type={'audio/mpeg'}
                                    />
                                </audio>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="info-panel-html">
                <div className="panel-background"></div>
                {this.getContentView.call(this, this.state.data)}
                <div
                    className="btn btn-collapse"
                    onClick={() => {
                        this.setState({
                            isHiddenInfoPanel: !this.state.isHiddenInfoPanel,
                        });
                        this.props.onCollapse(!this.state.isHiddenInfoPanel);
                    }}
                >
                    {this.state.isHiddenInfoPanel ? (
                        <BiChevronRightCircle />
                    ) : (
                        <BiChevronLeftCircle />
                    )}
                </div>
            </div>
        );
    }
}
